import { useTranslation } from 'cng-web-lib'
import Namespace from '../../../constants/locale/Namespace'
import AceHighwayAbiInbond7512Keys from '../../../constants/locale/key/AceHighwayAbiInbond7512'



const ACEHighwayInbond7512TranslationText = () => {

    const { translate } = useTranslation([
        Namespace.ACE_HIGHWAY_ABI_INBOND_7512
    ])

    let bolTitle = translate(
        Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
        AceHighwayAbiInbond7512Keys.Bol.TITLE
    )
    let saveButton = translate(
        Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
        AceHighwayAbiInbond7512Keys.SAVE_BUTTON
    )
    let updateButton = translate(
        Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
        AceHighwayAbiInbond7512Keys.UPDATE_BUTTON
    )
    let createInBond7512 = translate(
        Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
        AceHighwayAbiInbond7512Keys.CREATE_INBOND_7512
      )

    let addBol = translate(
        Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
        AceHighwayAbiInbond7512Keys.ADD_BOL
    )

    let masterBolIssuerCode = translate(
        Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
        AceHighwayAbiInbond7512Keys.Bol.MASTER_BOL_ISSUER_CODE
    )
    let masterBillNumber = translate(
        Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
        AceHighwayAbiInbond7512Keys.Bol.MASTER_BILL_NUMBER
    )
    let houseBillNumber = translate(
        Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
        AceHighwayAbiInbond7512Keys.Bol.HOUSE_BILL_NUMBER
    )
    let inbondQuantity = translate(
        Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
        AceHighwayAbiInbond7512Keys.Bol.INBOND_QUANTITY
    )
    let searchEntries = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.SEARCH_ENTRIES
    )

    let bolContainer = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.TITLE
    )
    let containerNumber = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.CONTAINER_NUMBER
    )
    let sealNumber1 = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.SEAL_NUMBER1
    )
    let sealNumber2 = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.SEAL_NUMBER2
    )
    let containerDescriptionCode = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.CONTAINER_DESCRIPTION_CODE
    )

    let addContainer = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.ADD_CONTAINER
    )

    let abiInbond7512 = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.TITLE
    )
    let id = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.ID
    )
    let createdBy = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.CREATED_BY
    )
    let createdDate = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.CREATED_DATE
    )
    let updatedBy = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.UPDATED_BY
    )
    let updatedDate = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.UPDATED_DATE
    )
    let submittedBy = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.SUBMITTED_BY
    )
    let submittedDate = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.SUBMITTED_DATE
    )
    let version = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.VERSION
    )
    let partyId = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.PARTY_ID
    )
    let filerCode = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.FILER_CODE
    )
    let portCode = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.PORT_CODE
    )
    let actionCode = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.ACTION_CODE
    )
    let bondNumber = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.BOND_NUMBER
    )
    let entryType = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.ENRTY_TYPE
    )
    let inbondCarrierCode = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.INBOND_CARRIER_CODE
    )
    let destinationPort = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.DESTINATION_PORT
    )
    let foreignPort = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.FOREIGN_PORT
    )
    let inbondValue = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.INBOND_VALUE
    )
    let inbondCarrierId = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.INBOND_CARRIER_ID
    )
    let ftzIndicator = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.FTZ_INDICATOR
    )
    let btaFdaIndicator = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.BTA_FDA_INDICATOR
    )
    let status = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.STATUS
    )
    let responseDate = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.RESPONSE_DATE
    )
    let editButton = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.EDIT_BUTTON
    )
    let cloneButton = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.CLONE_BUTTON
    )
    let deleteButton = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.DELETE_BUTTON
    )
    let backToInbond7512List = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.BACK_TO_INBOND_7512_LIST
    )
    let inbond7512Response = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.INBOND_7512_RESPONSE
    )
    
    let tripNumber = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.TRIP_NUMBER
    )
   
    let editSentRecords = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.EDIT_SENT_RECORDS
    )
   
    let deleteDraftRecords = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.DELETE_DRAFT_RECORDS
    )
   
    let printAbiInbond = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.PRINT_ABI_INBOND
    )

    let createInBond7512Button = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.CREATE_INBOND_7512_BUTTON
    )

    let uploadInbond7512 = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.UPLOAD_INBOND_7512
    )
    let parties = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.Parties.TITLE
    )
    let partyType = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.Parties.PARTY_TYPE
    )
    let name = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.Parties.NAME
    )
    let address1 = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.Parties.ADDRESS1
    )
    let address2 = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.Parties.ADDRESS2
    )
    let address3 = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.Parties.ADDRESS3
    )
    let telNo = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.Parties.TELNO
    )
    let partyDropDown = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.Parties.PARTY_DROP_DOWN
    )
    let saveFlag = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.Parties.SAVE_FLAG
    )
    let faxNo = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.Parties.FAXNO
    )
    let BTAFDARegulated = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.BTAFDA_REGULATED
    )
    let notBTAFDARegulated = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.NOT_BTAFDA_REGULATED
    )
    let FTZRegulated = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.FTZ_REGULATED
    )
    let notFTZregulated = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.NOT_FTZ_REGULATED
    )
    let uploadInbondErrorMsg = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.UPLOAD_INBOND_ERROR_MSG
    )
    let uploadNewInbond = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.UPLOAD_NEW_INBOND
    )
    let billOfLadingTitle = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.TITLE
    )
    let previousEntryType = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.PREVIOUS_ENTRY_TYPE
    )
    let previousInbondNumber = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.PREVIOUS_INBOND_NUMBER
    )
    let secondaryNotifyPartyCode1 = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.SECONDARY_NOTIFY_PARTY_CODE_1
    )
    let secondaryNotifyPartyCode2 = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.SECONDARY_NOTIFY_PARTY_CODE_2
    )
    let secondaryNotifyPartyCode3 = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.SECONDARY_NOTIFY_PARTY_CODE_3
    )
    let secondaryNotifyPartyCode4 = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.SECONDARY_NOTIFY_PARTY_CODE_4
    )
    let referenceInformation = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.REFERENCE_INFORMATION
    )
    let qualifier = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.QUALIFIER
    )
    let referenceIdentifier = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.REFERENCE_IDENTIFIER
    )
    let additionalBOLIndicator = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.ADDITIONAL_BOL_INDICATOR
    )
    let containerizedIndicator = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.CONTAINERIZED_INDICATOR
    )
    let bolDetails = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.AdditionalBolDetails.TITLE
    )
    let foreignPortOfLading = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.AdditionalBolDetails.FOREIGN_PORT_OF_LADING
    )
    let manifestQuantity = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.AdditionalBolDetails.MANIFEST_QUANTITY
    )
    let manifestUnit = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.AdditionalBolDetails.MANIFEST_UNIT
    )
    let weight = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.AdditionalBolDetails.WEIGHT
    )
    let weightUnit = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.AdditionalBolDetails.WEIGHT_UNIT
    )
    let volume = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.AdditionalBolDetails.VOLUME
    )
    let volumeUnit = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.AdditionalBolDetails.VOLUME_UNIT
    )
    let placeOfPrereceipt = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.AdditionalBolDetails.PLACE_OF_PRERECEIPT
    )
    let partiesTitle = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.Parties.TITLE
    )
    let billCargoDesc = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.BillCargoDesc.TITLE
    )
    let pieceCount = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.BillCargoDesc.PIECE_COUNT
    )
    let description = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.BillCargoDesc.DESCRIPTION
    )
    let manifestUnitCode = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.BillCargoDesc.MANIFEST_UNIT_CODE
    )
    let htsInformation = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.HtsInformation.TITLE
    )
    let harmonizedNumber = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.HtsInformation.HARMONIZED_NUMBER
    )
    let htsValue = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.HtsInformation.VALUE
    )
    let htsWeight = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.HtsInformation.WEIGHT
    )
    let htsWeightUom = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.HtsInformation.WEIGHT_UNIT
    )
    let note2PartiesRequired = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.NOTE_2PARTIES_REQUIRED
    )
    let noteAtLeast1Container = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.NOTE_AT_LEAST_1CONTAINER
    )
    let hazmatInformation = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.HazmatInformation.TITLE
    )
    let hazardousMaterialCode = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.HazmatInformation.HAZARDOURS_MATERIAL_CODE
    )
    let hazardousMaterialClass = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.HazmatInformation.HAZARDOURS_MATERIAL_CLASS
    )
    let hazardousMaterialCodeQual = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.HazmatInformation.HAZARDOURS_MATERIAL_CODE_QUAL
    )
    let hazardousMaterialDescription = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.HazmatInformation.HAZARDOURS_MATERIAL_DESCRIPTION
    )
    let hazardousMaterialContact = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.HazmatInformation.HAZARDOURS_MATERIAL_CONTACT
    )
    let flashpointTemperature = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.HazmatInformation.FLASHPOINT_TEMPERATURE
    )
    let uomCode = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.HazmatInformation.UOM_CODE
    )
    let negativeIndicator = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.HazmatInformation.NEGATIVE_INDICATOR
    )
    let hazardousMaterialDescription1 = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.HazmatInformation.HAZARDOURS_MATERIAL_DESCRIPTION1
    )
    let hazardousMaterialClassification1 = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.HazmatInformation.HAZARDOURS_MATERIAL_CLASSIFICATION1
    )
    let hazardousMaterialDescription2 = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.HazmatInformation.HAZARDOURS_MATERIAL_DESCRIPTION2
    )
    let hazardousMaterialClassification2 = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.HazmatInformation.HAZARDOURS_MATERIAL_CLASSIFICATION2
    )
    let marksAndNumbersTitle = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.MarksAndNumbers.TITLE
    )
    let marksAndNumbers = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.MarksAndNumbers.MARKS_AND_NUMBERS
    )
    let hazmatOtherDescAndClassification = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.HazmatInformation.HAZMAT_OTHER_DESC_AND_CLASSIFICATION
    )
    let flashpointIndicator = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.BolContainer.HazmatInformation.FLASHPOINT_INDICATOR
    )
    let secondaryNotifyPartyCode = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.Bol.SECONDARY_NOTIFY_PARTY_CODE
    )
    let inbondHeader = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.INBOND_HEADER
    )
    let inbondCarrierIdType = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.INBOND_CARRIER_ID_TYPE
    )
    let inbondCarrierIdNote = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.INBOND_CARRIER_ID_NOTE
    )
    let inbondCarrierIdIRS = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.INBOND_CARRIER_ID_IRS
    )
    let inbondCarrierIdSSN = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.INBOND_CARRIER_ID_SSN
    )
    let inbondCarrierIdCBP = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.INBOND_CARRIER_ID_CBP
    )
    let conveyanceInformation = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.CONVEYANCE_INFORMATION
    )
    let conveyanceCarrierCode = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.CONVEYANCE_CARRIER_CODE
    )
    let mot = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.MOT
    )
    let carrierCountry = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.CARRIER_COUNTRY
    )
    let conveyanceName = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.CONVEYANCE_NAME
    )
    let arrivalPort = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.ARRIVAL_PORT
    )
    let eta = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.ETA
    )
    let ftzFirmsCode = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.FTZ_FIRMS_CODE
    )
    let bolSummary = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.BOL_SUMMARY
    )
    let noteAtLeastOneBOL = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.NOTE_AT_LEAST_ONE_BOL
    )
    let createInbond7512Tab = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.CREATE_INBOND_7512_TAB
    )
    let submitSuccessMsg = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.SUBMIT_SUCCESS_MSG
    )
    let exportInbond7512 = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.EXPORT_INBOND_7512
    )    
    let exportInbond7512Msg = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.EXPORT_INBOND_7512_MSG
    )     
    let bolContainerRequired = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_7512,
      AceHighwayAbiInbond7512Keys.BOL_CONTAINER_REQUIRED
    )


    return {
      createInBond7512,
      bolTitle,
      saveButton,
      updateButton,
      addBol,
      masterBolIssuerCode,
      masterBillNumber,
      houseBillNumber,
      inbondQuantity,
      searchEntries,
      bolContainer,
      containerNumber,
      sealNumber1,
      sealNumber2,
      containerDescriptionCode,
      addContainer,
      abiInbond7512,
      id,
      createdBy,
      createdDate,
      updatedBy,
      updatedDate,
      submittedBy,
      submittedDate,
      version,
      partyId,
      filerCode,
      portCode,
      actionCode,
      bondNumber,
      entryType,
      inbondCarrierCode,
      destinationPort,
      foreignPort,
      inbondValue,
      inbondCarrierId,
      ftzIndicator,
      btaFdaIndicator,
      status,
      responseDate,
      editButton,
      cloneButton,
      deleteButton,
      backToInbond7512List,
      inbond7512Response,
      tripNumber,
      editSentRecords,
      deleteDraftRecords,
      printAbiInbond,
      createInBond7512Button,
      uploadInbond7512,
      parties,
      partyType,
      name,
      address1,
      address2,
      address3,
      telNo,
      partyDropDown,
      saveFlag,
      faxNo,
      BTAFDARegulated,
      notBTAFDARegulated,
      FTZRegulated,
      notFTZregulated,
      uploadInbondErrorMsg,
      uploadNewInbond,
      billOfLadingTitle,
      previousEntryType,
      previousInbondNumber,
      secondaryNotifyPartyCode1,
      secondaryNotifyPartyCode2,
      secondaryNotifyPartyCode3,
      secondaryNotifyPartyCode4,
      referenceInformation,
      qualifier,
      referenceIdentifier,
      additionalBOLIndicator,
      containerizedIndicator,
      bolDetails,
      foreignPortOfLading,
      manifestQuantity,
      manifestUnit,
      weight,
      weightUnit,
      volume,
      volumeUnit,
      placeOfPrereceipt,
      partiesTitle,
      billCargoDesc,
      pieceCount,
      description,
      manifestUnitCode,
      htsInformation,
      harmonizedNumber,
      htsValue,
      htsWeight,
      htsWeightUom,
      note2PartiesRequired,
      noteAtLeast1Container,
      hazmatInformation,
      hazardousMaterialCode,
      hazardousMaterialClass,
      hazardousMaterialCodeQual,
      hazardousMaterialDescription,
      hazardousMaterialContact,
      flashpointTemperature,
      uomCode,
      negativeIndicator,
      hazardousMaterialDescription1,
      hazardousMaterialClassification1,
      hazardousMaterialDescription2,
      hazardousMaterialClassification2,
      marksAndNumbersTitle,
      marksAndNumbers,
      hazmatOtherDescAndClassification,
      flashpointIndicator,
      secondaryNotifyPartyCode,
      inbondHeader,
      inbondCarrierIdType,
      inbondCarrierIdNote,
      inbondCarrierIdIRS,
      inbondCarrierIdSSN,
      inbondCarrierIdCBP,
      conveyanceInformation,
      conveyanceCarrierCode,
      mot,
      carrierCountry,
      conveyanceName,
      arrivalPort,
      eta,
      ftzFirmsCode,
      bolSummary,
      flashpointIndicator,
      noteAtLeastOneBOL,
      createInbond7512Tab,
      submitSuccessMsg,
      exportInbond7512,
      exportInbond7512Msg,
      bolContainerRequired
    }

}


export default ACEHighwayInbond7512TranslationText

